export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapCameras';
export const ENTITY_EDIT_ROUTE = 'video/cameras';
